import { customElement } from 'aurelia';
import template from './confirm-dialog.html';

type Resolver = (value: boolean) => void;

@customElement({ name: 'confirm-dialog', template })
export class ConfirmDialog {
  public visible = false;
  public title = '';
  public message = '';
  public isAlert = false;

  private _resolve?: Resolver;
  private static _instance?: ConfirmDialog;

  public attached(): void {
    ConfirmDialog._instance = this;
  }

  public detached(): void {
    if (ConfirmDialog._instance === this) {
      ConfirmDialog._instance = undefined;
    }
  }

  public static confirm(message: string, title = ''): Promise<boolean> {
    if (!ConfirmDialog._instance) return Promise.resolve(window.confirm(message));
    return ConfirmDialog._instance._show(message, title, false);
  }

  public static alert(message: string, title = ''): Promise<void> {
    if (!ConfirmDialog._instance) { window.alert(message); return Promise.resolve(); }
    return ConfirmDialog._instance._show(message, title, true).then(() => undefined);
  }

  private _show(message: string, title: string, isAlert: boolean): Promise<boolean> {
    this.message = message;
    this.title = title;
    this.isAlert = isAlert;
    this.visible = true;
    return new Promise(resolve => { this._resolve = resolve; });
  }

  public ok(): void {
    this.visible = false;
    this._resolve?.(true);
  }

  public cancel(): void {
    this.visible = false;
    this._resolve?.(false);
  }
}
